import type { UIMessage } from 'ai';
import type { ChatModelId } from '@/components/Messenger/agent/AgentModelControls';

export interface ChatAttachedProjectPayload {
  id: string;
  name: string;
}

export interface ChatAttachedSessionPayload {
  id: string;
  date: string;
  project_id?: string;
  label: string;
}

/** Пользователь приложил к сообщению контекст планера (инструмент «Планер»). */
export type ChatAttachedPlannerPayload = Record<string, never>;

export type TrackerChatDataTypes = {
  chatAttachedProject: ChatAttachedProjectPayload;
  chatAttachedSession: ChatAttachedSessionPayload;
  chatAttachedPlanner: ChatAttachedPlannerPayload;
};

export type TrackerChatMessage = UIMessage<
  {
    sendFailed?: boolean;
    modelSlot?: ChatModelId;
    /** ISO с сервера — разделители дней и мета времени в unified-ленте */
    messageCreatedAt?: string;
  },
  TrackerChatDataTypes
>;

export const CHAT_PART_ATTACHED_PROJECT = 'data-chatAttachedProject' as const;
export const CHAT_PART_ATTACHED_SESSION = 'data-chatAttachedSession' as const;
export const CHAT_PART_ATTACHED_PLANNER = 'data-chatAttachedPlanner' as const;

/**
 * Личный чат: вложения в композере.
 * - `add_photo` — кнопка «Добавить фото»: всегда сжатие в JFIF, в композере миниатюра.
 * - `add_file` — «Прикрепить файл»: картинки грузятся как `application/octet-stream` (в чате ссылка), в композере бейдж.
 * - `paste_or_drop` — только вставка/DnD: после модалки либо сжатие (превью), либо как файл (бейдж + octet для image/*).
 */
export type DirectComposerPendingFile =
  | { source: 'add_photo'; file: File }
  | { source: 'add_file'; file: File }
  | { source: 'paste_or_drop'; file: File; sendAsAttachment: boolean };

export function directComposerPendingShowsThumbnail(item: DirectComposerPendingFile): boolean {
  if (item.source === 'add_photo') return true;
  if (item.source === 'add_file') return false;
  return !item.sendAsAttachment;
}
